






































import { Component, Vue, Prop } from 'vue-property-decorator';
import router from '../../router';
import { vxm } from '../../store.vuex';
import RegistrationCard from './Card.vue';
import Container from './Container.vue';

@Component({
  name: 'RetrievedEmailVerification',
  components: {
    RegistrationCard,
    Container,
  },
})
export default class RetrievedEmailVerification extends Vue {
  private retrievedEmail: string = '';
  $wlToastr: any;

  redirectLogin() {
    console.log('Redirecting to login');
    router.push({ name: 'Signup' });
  }

  get companyRetrievedEmailContent() {
    return vxm.configs.getGlobalConfigValue('RETRIEVED_EMAIL_VERIFICATION_TEXT') || "An SMS has been sent to your mobile Number with the Email ID information. Please verify that Email ID below and continue with the sign up either by using retrived Email ID or your social media account.";
  }
  
  redirectValidate() {
    const vm = this;
    const respPromise: any = vxm.users.validateRetrievedEmail(
      this.retrievedEmail,
    );
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        vxm.users.setDuplicateCheckRequired(false);
        vxm.users.setPopulateSignupPage(true);
        vxm.users.setRetrievedEmail(this.retrievedEmail);
        if (vxm.users.UserParams.isSocialMediaSignup) {
          router.push({ name: 'RetrievedEmailSignupPreference' });
        } else {
          router.push({ name: 'Signup' });
        }
      } else {
        const error = values[0].error;
        vm.$wlToastr('error', error, 'Verification');
      }
    });
  }
}
